export default "__VITE_ASSET__BfVSUEne__"